import { coreServiceUrl } from '../../../../config/environment';
import { callApi } from '../../../../utils/callApi';
import { ArticleDefinition } from '../../core-service.types';

export const getArticleForParameterValuesApiCall = async (
  rootArticleNumber: string,
  parameterValueIds: string[],
  changedParameterValueId: string,
) => {
  const url = `${coreServiceUrl}/wsc/articles/get-by-parameters-values`;
  const { data } = await callApi<ArticleDefinition>(url, 'POST', {
    parameterValueIds,
    changedParameterValueId,
    rootArticleNumber: rootArticleNumber,
  });
  return data;
};
